import getConfig from 'next/config';
import type { AncestorCategory, PathCategory } from '../../codegen/types';
import { Locale } from '../internationalization';

const config = getConfig()?.publicRuntimeConfig || process.env;

const homeTranslationMapper: { [key: string]: string } = {
  en: 'Home',
  fr: 'Accueil',
};

export function addBreadcrumbListJson(
  categoriesPath?: PathCategory[] | AncestorCategory[],
  locale?: string,
  name?: string, // to be used with category pages only
  currentCategoryKey?: string,
  currentCategorySlug?: string,
) {
  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
  };

  const itemListElement = [
    {
      '@type': 'ListItem',
      position: 1,
      name: homeTranslationMapper[locale?.substring(0, locale.indexOf('-')) || Locale.DEFAULT_LOCALE],
      item: `${config.STOREFRONT_CDN_URL}/${locale}`,
    },
  ];

  const categoriesData =
    categoriesPath?.map((category, idx) => ({
      '@type': 'ListItem',
      position: idx + 2,
      name: category?.name || '',
      item: `${config.STOREFRONT_CDN_URL}/${locale}/${category.slug}/${category.key}-c`,
    })) || [];

  // to add the category page itself to the schema
  if (name && currentCategoryKey && currentCategorySlug) {
    categoriesData.push({
      '@type': 'ListItem',
      position: categoriesData.length + 2,
      name,
      item: `${config.STOREFRONT_CDN_URL}/${locale}/${currentCategorySlug}/${currentCategoryKey}-c`,
    });
  }
  itemListElement?.push(...categoriesData);

  return {
    __html: JSON.stringify({ ...structuredData, ...{ itemListElement } }, null, 2),
  };
}
